// cart-notification.js

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // This ensures the notification can be closed
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  // --- THIS METHOD WAS MISSING ---
  // It is responsible for making the notification visible
  open() {
    this.notification.classList.add('animate', 'active'); // Adds the classes you need
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      // The trapFocus function is usually globally available in Shopify themes
      if (typeof trapFocus === 'function') {
        trapFocus(this.notification);
      }
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  // This method handles closing the notification
  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    // The removeTrapFocus function is also usually global
    if (typeof removeTrapFocus === 'function' && this.activeElement) {
        removeTrapFocus(this.activeElement);
    }
  }

  // This helper function builds the HTML for one product
  createProductHTML(item) {
    // The HTML structure for a single product item
    return `
      <div class="cart-notification-product__item">
        ${
          item.image
            ? `<img class="cart-notification-product__image" src="${item.image}" alt="${item.product_title}" width="70" height="auto" loading="lazy">`
            : ''
        }
        <div class="cart-notification-product__info">
          <h3 class="cart-notification-product__name h4">${item.product_title}</h3>
          ${
            item.variant_title && !item.variant_title.includes('Default')
              ? `<dl><div class="product-option"><dt>Variant:</dt><dd>${item.variant_title}</dd></div></dl>`
              : ''
          }
        </div>
      </div>
    `;
  }

  // This is the main function called from product-form.js
  renderContents(cartData) {
    // 1. Build product HTML on the client side
    const productContainer = document.getElementById('cart-notification-product');
    if (productContainer && cartData.items) {
      let productsHTML = '';
      cartData.items.forEach(item => {
        productsHTML += this.createProductHTML(item);
      });
      productContainer.innerHTML = productsHTML;
    }

    // 2. Update other sections from the API response (e.g., cart bubble)
    if (cartData.sections) {
      Object.keys(cartData.sections).forEach((id) => {
        const elementToUpdate = document.getElementById(id);
        if (elementToUpdate) {
            const newElement = new DOMParser().parseFromString(cartData.sections[id], 'text/html').querySelector('.shopify-section');
            if (newElement) {
                elementToUpdate.innerHTML = newElement.innerHTML;
            }
        }
      });
    }

    // 3. Call the open() method to make the notification visible
    if (this.header) this.header.reveal();
    this.open();
  }

  // This allows the notification to close if you click outside of it
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }
  
  // Helper for accessibility
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);